export const containerTheme = {
  defaultStyles: {
    margin: '0 auto',
    width: '100%',
  },
  width: {
    md: 633 + 42 * 2,
    lg: 933 + 42 * 2,
    xl: undefined,
  },
  paddingX: {
    paddingLeft: '2.625rem',
    paddingRight: '2.625rem',
  },
  paddingY: {
    paddingTop: '1.5rem',
    paddingBottom: '1.5rem',
  },
};
